<template>
<div class="infoBG">
    <b-container v-if="!isMobile()">
        <b-row class="rowMargin"> 
            <b-col cols="4">
                <h2 class="heading">WHAT ARE <br> <span class="secondHeader">COSMIC VXs?</span></h2>
                <br>
                <p class="introPara">
                    COSMIC VX is an NFT collection comprised of 3000 programmatically generated Cosmic Labs Ducks, playable in The Sandbox. Each Duck is completely unique, hand-crafted from over 70 traits by our skilled voxel-artist.
                </p>
            </b-col>
            <b-col cols="1">

            </b-col>
            <b-col cols="1">

            </b-col>
            <b-col cols="6">
                <video class="VxVideo" src="../../assets/VX/video.mp4" autoplay="autoplay" loop="loop" muted="muted" playsinline=""></video>
            </b-col>
        </b-row>
    </b-container>


    <b-container v-if="isMobile()">
        <b-row>
            <b-col cols="12">
                <video class="VxVideo" src="../../assets/VX/video.mp4" autoplay="autoplay" loop="loop" muted="muted" playsinline=""></video>
                <h2 class="headingMobile">WHAT ARE <br> <span class="secondHeader">COSMIC VXs?</span></h2>
                <br>
                <p class="introPara">
                    COSMIC VX is an NFT collection comprised of 3000 programmatically generated Cosmic Labs Ducks, playable in The Sandbox. Each Duck is completely unique, hand-crafted from over 70 traits by our skilled voxel-artist.
                </p>
            </b-col>
        </b-row>
    </b-container>
</div>
</template>

<script>
export default {
    methods: {
        isMobile() {
            if(/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)) {
                return true
            } else {
                return false
            }
        }
    }
}
</script>

<style scoped>
.heading
{
    color: white;
    margin-top: 20vh;
    text-align: left;
    font-size: 3.5vh !important;
}
.headingMobile
{
    color: white;
    margin-top: 10vh;
    text-align: left;
    font-size: 3.5vh !important;
}
.introPara
{
    color: white;
    text-align: left;
    margin-bottom: 20vh;
    font-size: 2vh !important;
}
.infoBG
{
    background: #242424;
}
.secondHeader
{
    color: #14FFEC;
    text-align: left;
}

.VxVideo
{
    margin-top: 15vh;
    width: 60vh;
    border: 2px solid #82f5eb;
    
}
</style>


// WEBPACK FOOTER //
// src/components/Vx/Info.vue